import ManheimLogo from '../../../../shared/img/manheim/manheim-logo.svg';

import { RX } from '../../constants/rx';
import { COMPLETE_REGISTRATION } from '../../constants/resources';

const { flex } = window;
const {
    React,
    ReactAddons: { PropTypes }
} = flex.lib;

const { PrismButton, loader } = flex.components;

class CompleteRegistration extends React.PureComponent {
    static propTypes = {
        registrationToken: PropTypes.string.isRequired,
        redirectMessage: PropTypes.string,
        userHasManheimAccount: PropTypes.bool,
        registrationTokenNotFound: PropTypes.bool,
        userRegistrationInformationIsLoading: PropTypes.bool
    };

    static defaultProps = {
        userHasManheimAccount: false,
        registrationTokenNotFound: false,
        userRegistrationInformationIsLoading: true
    };

    componentDidMount() {
        flex.trigger(RX.COMPLETE_REGISTRATION.CLEAR_BRANCH);
        flex.trigger(RX.COMPLETE_REGISTRATION.GET_ORG_USER_BY_TOKEN, this.props.registrationToken);
    }

    onClickSignInWithManheimAccount = () => {
        flex.trigger(
            RX.COMPLETE_REGISTRATION.SIGN_IN_WITH_MANHEIM_ACCOUNT,
            this.props.registrationToken
        );
    };

    onClickCreateNewAccount = () => {
        flex.trigger(RX.COMPLETE_REGISTRATION.CREATE_NEW_ACCOUNT, this.props.registrationToken);
    };

    render() {
        const {
            userHasManheimAccount,
            registrationTokenNotFound,
            userRegistrationInformationIsLoading
        } = this.props;

        if (userRegistrationInformationIsLoading) {
            return loader;
        }

        return (
            <section className="container complete-registration">
                <header>
                    <h1 className="complete-registration__header">
                        {COMPLETE_REGISTRATION.HEADER}
                    </h1>
                </header>
                <div className="complete-registration__buttons-container">
                    <PrismButton
                        className="complete-registration__button"
                        outline
                        disabled={registrationTokenNotFound}
                        onClick={this.onClickSignInWithManheimAccount}
                    >
                        <img src={ManheimLogo} className="complete-registration__logo" />
                        <span className="complete-registration__button-label">
                            {COMPLETE_REGISTRATION.SIGN_IN_OPTION_BTN}
                        </span>
                    </PrismButton>
                    <p className="complete-registration__text">OR</p>
                    <PrismButton
                        className="complete-registration__button complete-registration__text-button"
                        outline
                        disabled={userHasManheimAccount || registrationTokenNotFound}
                        onClick={this.onClickCreateNewAccount}
                    >
                        {COMPLETE_REGISTRATION.CREATE_NEW_ACCOUNT_OPTION_BTN}
                    </PrismButton>
                </div>
            </section>
        );
    }
}

export default CompleteRegistration;
